import { axiosClient,type IResponse } from '~/common/js/axios';
import type { AxiosRequestConfig } from 'axios';

/**
* 商家上线
*/
export function onLine_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/onLine',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 商家下线
*/
export function offLine_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/offLine',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 商家缴纳保证金
*/
export function deposit_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/deposit',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 商家解冻保证金
*/
export function unDeposit_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/unDeposit',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 更新商家个人信息
*/
export function updateMerchantInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/updateMerchantInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface getMerchantInfo_POST_res_type {
  /** 用户cid */ 
  cid: number 
  /** 用户类型，1 用户，2商家 */ 
  type: number 
  /** 用户类型，0普通用户，1 认证商家，2钻石商家， */ 
  level: number 
  /** undefined */ 
  followed: boolean 
  /** 用户状态0正常，1下线，2禁止p2p交易 */ 
  state: number 
  /** 昵称 */ 
  nickName: string 
  /** 真实姓名 */ 
  realName: string 
  /** 国家 */ 
  country: string 
  /** 是否已认证商家 */ 
  platformVerified: boolean 
  /** 注册时间 */ 
  registeredTime: string 
  /** id认证状态 */ 
  idVerified: boolean 
  /** 手机认证状态 */ 
  phoneVerified: boolean 
  /** 邮箱认证状态 */ 
  emailVerified: boolean 
  /** 总成交额- usd */ 
  orderQuantity: string 
  /** 总创建订单 */ 
  orderCreate: string 
  /** 总创建买订单 */ 
  orderCreateBuy: string 
  /** 总创建卖订单 */ 
  orderCreateSell: string 
  /** 总完成单数 */ 
  orderComplete: string 
  /** 总完成买单数 */ 
  orderCompleteBuy: string 
  /** 总完成卖单数 */ 
  orderCompleteSell: string 
  /** 总完成率 */ 
  finishRate: string 
  /** 总买单完成率 */ 
  finishRateBuy: string 
  /** 总卖单完成率 */ 
  finishRateSell: string 
  /** 平均付款时间 */ 
  avgPayTime: string 
  /** 平均放币时间 */ 
  avgReleaseTime: string 
  /** 最近30天总成交额- usd */ 
  orderQuantity30day: string 
  /** 最近30天总创建订单 */ 
  orderCreate30day: string 
  /** 最近30天总创建买订单 */ 
  orderCreateBuy30day: string 
  /** 最近30天总创建卖订单 */ 
  orderCreateSell30day: string 
  /** 最近30天总完成单数 */ 
  orderComplete30day: string 
  /** 最近30天总完成买单数 */ 
  orderCompleteBuy30day: string 
  /** 最近30天总完成卖单数 */ 
  orderCompleteSell30day: string 
  /** 最近30天总完成率 */ 
  finishRate30day: string 
  /** 最近30天总买单完成率 */ 
  finishRateBuy30day: string 
  /** 最近30天总卖单完成率 */ 
  finishRateSell30day: string 
  /** 最近30天平均付款时间 */ 
  avgPayTime30day: string 
  /** 最近30天平均放币时间 */ 
  avgReleaseTime30day: string 
  /** 交易完成用户数 */ 
  usersTradeWith: string 
  /** 最近30天交易完成用户数 */ 
  usersTradeWith30day: string 
  /** 背景颜色 */ 
  bgColor: string 
  /** 是否白名单用户 */ 
  isWhiteList: boolean 
  /** 是否可以直接升级为钻石商家 */ 
  isDiamondEnough: boolean 
}
/**
* 查询商家个人信息，cid
*/
export function getMerchantInfo_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<getMerchantInfo_POST_res_type>>({
    url: '/gw-api/p2p-user/p2p/merchant/getMerchantInfo',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}


/**
* 申请成为商家
*/
export function apply_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<any>>({
    url: '/gw-api/p2p-user/p2p/merchant/apply',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface IMerchantConditions {
  phoneAndEmailVerification?:	boolean	
  kycVerification?:	boolean	
  // 余额是否足够扣减保证金	
  balanceEnough?:	boolean	
  // 余额是否足够扣减直达钻石保证金	

  directDiamondBalanceEnough?:	boolean	
  // 成为认证商家天数是否足够	

  verifiedDays?:	boolean	
    // 月完成订单是否足够	

  monthlyCompletedOrders?:	boolean	
    // 月交易额是否足够	

  monthlyTradingVolume?:	boolean	
    // 月成交人数是否足够	

  monthlyTradingUsers?:	boolean	
  monthlyOrderCompletionRate?:boolean,
}

/**
* 获取商家资质
*/
export function getMerchantConditions_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<IMerchantConditions>>({
    url: '/gw-api/p2p-user/p2p/merchant/getUserConditions',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}

export interface IMerchantRules {
  // 是否需要手机和邮箱认证
  phoneAndEmailVerification?: boolean,
  // 是否需要Kyc认证
  kycVerification?: boolean,	
  // 冻结金额	
  depositAmount?:	number	
  // 成为认证商家天数	
  verifiedDays?:	number	
  // 月完成订单数	
  monthlyCompletedOrders?:	number
  // 月交易额	
  monthlyTradingVolume?:	number	
  // 月交易对手数量
  monthlyTradingUsers?:	number
  // 月订单完成率
  monthlyOrderCompletionRate?:	number	
  // 直达钻石商家保证金	
  directDiamondAmount?: number
}

/**
* 获取商家申请规则
*/
export function getMerchantApplyRules_post(options?: any, overwriteParams?: AxiosRequestConfig) {
  return axiosClient<any, IResponse<IMerchantRules>>({
    url: '/gw-api/p2p-user/p2p/merchant/getConditions',
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...(options && options.headers ? options.headers : {}) },
    data: (options && options.data) || {},
    ...(overwriteParams || {}),
  });
}